// HealthyFood component - Converted from components/HealthyFood.vue
// Healthy food section
// Converted: <template> -> JSX, :style -> style, :src -> src
import React from 'react';
import healthyFoodBg from '../assets/images/resources/helathy_food_bg.jpg';

const HealthyFood = () => {
  return (
    <section className="healthy_food">
      <div className="healthy_food_bg" style={{ backgroundImage: `url(${healthyFoodBg})` }}></div>
      <div className="container">
        <div className="block-title text-left">
          <p>CE QUE NOUS FAISONS</p>
          <h3 style={{ lineHeight: '1.2' }}>L&apos;EXCELLENCE <br /> DE NOS OLIVES</h3>
        </div>
        <div className="row">
          <div className="col-xl-6">
            <div className="healthy_food_text">
              <p>
                Chez Leaders Agro Elite, nous sommes fiers de cultiver des oliviers de qualité
                supérieure, en utilisant des méthodes agricoles durables pour produire une huile
                d&apos;olive extra vierge d&apos;exception. Nos experts agronomes offrent des conseils
                personnalisés et un soutien technique pour optimiser vos récoltes et assurer la
                prospérité de votre exploitation.
              </p>
            </div>
            <ul className="healthy_food_box list-unstyled">
              <li className="healthy_food_single">
                <span className="icon-harvest"></span>
                <h3>RÉCOLTE</h3>
              </li>
              <li className="healthy_food_single">
                <span className="icon-focus"></span>
                <h3>ENGRAIS</h3>
              </li>
              <li className="healthy_food_single">
                <span className="icon-tractor"></span>
                <h3>SEMENCE</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthyFood;
